module.exports = __webpack_public_path__ + "img/icon_skip.76dd661e.svg";